import { useEffect, useState } from "react";

// Hooks
import { usePlacesAutocomplete } from "@/DataPages/hooks/crm/address/usePlacesAutocomplete";

// Components
import SmartSelector from "../../InputComponents/SmartSelector";
import { LabeledFormInput } from "../LabeledFormInput";
import { ISmartSelectorProps } from "../../InputComponents/SmartSelector/interfaces";

function isValidAddress(address: AutocompleteSuggestion | null) {
	return Boolean(address?.placeId) && Boolean(address?.searchableText);
}

type TSmartAddressInputProps = {
	addable?: boolean;
	onSelectedAddress?: (selectedAddress: AutocompleteSuggestion | null) => void;
	inferredAddress?: string | null;
	autocompleteBias?: string[];
	selectorProps?: Partial<ISmartSelectorProps>;
	required?: boolean;
	disabled: boolean;
	loading: boolean;
};

export function SmartAddressInput(props: Readonly<TSmartAddressInputProps>) {
	const {
		addable = false,
		onSelectedAddress,
		inferredAddress = null,
		autocompleteBias = [],
		required = false,
		disabled,
		loading,
	} = props;
	const [inputAddress, setInputAddress] = useState<string>("");
	const { suggestions } = usePlacesAutocomplete({ input: inputAddress, bias: autocompleteBias });
	const [selectedAddress, setSelectedAddress] = useState<AutocompleteSuggestion | null>(null);

	useEffect(() => {
		const injected = {
			placeId: inferredAddress ?? "",
			searchableText: inferredAddress ?? "",
		} as AutocompleteSuggestion;
		setSelectedAddress(injected);
	}, [inferredAddress]);

	return (
		<LabeledFormInput
			label="Address 1"
			formInput={
				<SmartSelector
					addable={addable}
					clearable
					inputProps={{
						placeholder: "Address 1",
					}}
					options={suggestions ?? [{ placeId: "no-suggestion", searchableText: "No results found" }]}
					selectBy="placeId"
					showBy="searchableText"
					onInputChangeAction={setInputAddress}
					selected={selectedAddress}
					onChangeAction={(selected) => {
						const selectedSuggestion = selected as AutocompleteSuggestion;
						setSelectedAddress(selectedSuggestion);
						onSelectedAddress?.(selectedSuggestion);
					}}
					error={required && !isValidAddress(selectedAddress)}
					popperProps={props?.selectorProps?.popperProps}
					disabled={disabled}
					loading={loading}
				/>
			}
		/>
	);
}

export default SmartAddressInput;
